var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.listTitle } },
    [
      _c("template", { slot: "pageContent" }, [
        _vm.isSmartphoneOS
          ? _c("div", { attrs: { slot: "fixed" }, slot: "fixed" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "44px",
                    width: "100%",
                  },
                },
                [
                  _vm.serviceId === _vm.services.DOCUMENTSERVICE &&
                  !_vm.sharedFoldersConfig
                    ? _c("cm-messages-filter", {
                        staticClass: "researchfilter",
                        staticStyle: { position: "relative", "z-index": "10" },
                        attrs: {
                          isPayments: "",
                          received: "",
                          filterType: "details",
                          mode: this.mode,
                        },
                        on: {
                          applyFilter: function ($event) {
                            return _vm.applyFilter($event)
                          },
                        },
                      })
                    : _vm.serviceId === _vm.services.DIRECTPAYMENTS &&
                      _vm.mode === 0
                    ? _c("cm-messages-filter", {
                        staticClass: "researchfilter",
                        staticStyle: { position: "relative", "z-index": "10" },
                        attrs: {
                          isPayments: "",
                          received: "",
                          filterType: "draft",
                          mode: this.mode,
                        },
                        on: {
                          applyFilter: function ($event) {
                            return _vm.applyFilter($event)
                          },
                        },
                      })
                    : _vm.serviceId === _vm.services.PAYMENTS && _vm.mode === 2
                    ? _c("cm-messages-filter", {
                        staticClass: "researchfilter",
                        staticStyle: { position: "relative", "z-index": "10" },
                        attrs: {
                          isPayments: "",
                          received: "",
                          filterType: "group",
                          mode: this.mode,
                        },
                        on: {
                          applyFilter: function ($event) {
                            return _vm.applyFilter($event)
                          },
                        },
                      })
                    : _c("cm-messages-filter", {
                        staticClass: "researchfilter",
                        staticStyle: { position: "relative", "z-index": "10" },
                        attrs: {
                          isPayments: "",
                          received: "",
                          filterType: "list",
                          mode: this.mode,
                        },
                        on: {
                          applyFilter: function ($event) {
                            return _vm.applyFilter($event)
                          },
                        },
                      }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "listPage", staticStyle: { overflow: "hidden" } },
          [
            false
              ? _c(
                  "b-row",
                  {
                    staticClass:
                      "form-group justify-content-start showLargeScreenOnly",
                  },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "1" } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn",
                            attrs: { disabled: _vm.activateSpinner },
                            on: {
                              click: function ($event) {
                                return _vm.refreshInbox()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-light fa-rotate-right",
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "fab-label" }, [
                              _vm._v(_vm._s(_vm.$t("common.rfrsh"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "1", "offset-md": "6" } },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              disabled: _vm.activateSpinner,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.extractCSV()
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa-light fa-upload" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "fab-label" }, [
                              _vm._v(_vm._s(_vm.$t("common.extract"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.serviceId === _vm.services.SUPPLIERS
                      ? _c(
                          "b-col",
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "primary",
                                  href: "/suppliers/create/",
                                },
                              },
                              [
                                _c("i", { staticClass: "fa-light fa-plus" }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("common.add_label"))),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c("div", { staticClass: "requestsList" }, [
                      !_vm.isSmartphoneOS
                        ? _c(
                            "div",
                            [
                              _vm.serviceId === _vm.services.DOCUMENTSERVICE &&
                              !_vm.sharedFoldersConfig
                                ? _c("cm-messages-filter", {
                                    staticClass: "researchfilter",
                                    staticStyle: {
                                      position: "relative",
                                      "z-index": "10",
                                    },
                                    attrs: {
                                      isPayments: "",
                                      received: "",
                                      filterType: "details",
                                      mode: this.mode,
                                    },
                                    on: {
                                      applyFilter: function ($event) {
                                        return _vm.applyFilter($event)
                                      },
                                    },
                                  })
                                : _vm.serviceId ===
                                    _vm.services.DIRECTPAYMENTS &&
                                  _vm.mode === 0
                                ? _c("cm-messages-filter", {
                                    staticClass: "researchfilter",
                                    staticStyle: {
                                      position: "relative",
                                      "z-index": "10",
                                    },
                                    attrs: {
                                      isPayments: "",
                                      received: "",
                                      filterType: "draft",
                                      mode: this.mode,
                                      randomId: _vm.randomId,
                                    },
                                    on: {
                                      applyFilter: function ($event) {
                                        return _vm.applyFilter($event)
                                      },
                                    },
                                  })
                                : _vm.serviceId === _vm.services.PAYMENTS &&
                                  _vm.mode === 2
                                ? _c("cm-messages-filter", {
                                    staticClass: "researchfilter",
                                    staticStyle: {
                                      position: "relative",
                                      "z-index": "10",
                                    },
                                    attrs: {
                                      isPayments: "",
                                      received: "",
                                      filterType: "group",
                                      mode: this.mode,
                                      randomId: _vm.randomId,
                                    },
                                    on: {
                                      extractCSV: function ($event) {
                                        return _vm.extractCSV(_vm.inboxMessages)
                                      },
                                      applyFilter: function ($event) {
                                        return _vm.applyFilter($event)
                                      },
                                    },
                                  })
                                : _c("cm-messages-filter", {
                                    staticClass: "researchfilter",
                                    staticStyle: {
                                      position: "relative",
                                      "z-index": "10",
                                    },
                                    attrs: {
                                      isPayments: "",
                                      received: "",
                                      filterType: "list",
                                      mode: this.mode,
                                      randomId: _vm.randomId,
                                    },
                                    on: {
                                      extractCSV: function ($event) {
                                        return _vm.extractCSV(_vm.inboxMessages)
                                      },
                                      applyFilter: function ($event) {
                                        return _vm.applyFilter($event)
                                      },
                                    },
                                  }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isSmartphoneOS
                        ? _c("div", { style: _vm.customMobileLayoutStyle })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.mode === 1 && _vm.items.length
                      ? _c("b-table", {
                          staticClass: "mt-3",
                          attrs: {
                            hover: "",
                            fixed: "",
                            responsive: "",
                            items: _vm.items,
                            fields: _vm.fields,
                            "sort-by": _vm.sortField,
                            selectable: "",
                            "select-mode": "single",
                          },
                          on: { "row-selected": _vm.seeDetails },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mode === 2 && _vm.items_grp.length
                      ? _c("b-table", {
                          staticClass: "mt-3",
                          attrs: {
                            hover: "",
                            fixed: "",
                            responsive: "",
                            items: _vm.items_grp,
                            fields: _vm.fields_grp,
                            selectable: "",
                            "select-mode": "single",
                          },
                          on: { "row-selected": _vm.seeDetails_grp },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "mt-5" },
                      [
                        _c(
                          "b-col",
                          { attrs: { lg: "2", "offset-lg": "8" } },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.goBack("/home/")
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "d-none d-xl-inline" },
                                  [_vm._v(_vm._s(_vm.$t("common.prvs_page")))]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "d-xl-none" }, [
                                  _vm._v(_vm._s(_vm.$t("common.prvs"))),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { disabled: "", variant: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.goBack("none")
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "d-none d-xl-inline" },
                                  [_vm._v(_vm._s(_vm.$t("common.next_page")))]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "d-xl-none" }, [
                                  _vm._v(_vm._s(_vm.$t("common.next_page"))),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }